export default {
    SET_CLINICS (state, clinics) {
        state.clinics = clinics
      },
}